import { useHotKey } from '../../hooks/hotkey';
import { useRefGetter } from '@okee-uikit/react-hooks';
import React, { Fragment, useCallback } from 'react';
export function SelectHotKey(props) {
  var _props$handlers = props.handlers,
      handlers = _props$handlers === void 0 ? {} : _props$handlers,
      focusableElementRef = props.focusableElementRef;
  var handlersGetter = useRefGetter(handlers);
  var handleUp = useCallback(function () {
    var _a, _b, _c, _d;

    if (document.activeElement && document.activeElement === focusableElementRef.current) {
      (_b = (_a = focusableElementRef.current).scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, {
        behavior: 'smooth',
        block: 'nearest'
      });
      (_d = (_c = handlersGetter()).stepUp) === null || _d === void 0 ? void 0 : _d.call(_c);
    }

    return false;
  }, []);
  var handleDown = useCallback(function () {
    var _a, _b, _c, _d;

    if (document.activeElement && document.activeElement === focusableElementRef.current) {
      (_b = (_a = focusableElementRef.current).scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, {
        behavior: 'smooth',
        block: 'nearest'
      });
      (_d = (_c = handlersGetter()).stepDown) === null || _d === void 0 ? void 0 : _d.call(_c);
    }

    return false;
  }, []);
  var handleSelect = useCallback(function () {
    var _a, _b, _c, _d;

    if (document.activeElement && document.activeElement === focusableElementRef.current) {
      (_b = (_a = focusableElementRef.current).scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, {
        behavior: 'smooth',
        block: 'nearest'
      });
      (_d = (_c = handlersGetter()).selectBackFill) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
  }, []);
  useHotKey('up', handleUp, 'keydown');
  useHotKey('up', handleUp, 'keypress');
  useHotKey('down', handleDown, 'keydown');
  useHotKey('down', handleDown, 'keypress');
  useHotKey('enter', handleSelect, 'keydown');
  return React.createElement(Fragment, null);
}